module.exports = __webpack_public_path__ + "img/Lindsay Sheft.d7910f00.jpg";